"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textStyles = exports.newTextStyles = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _fonts = require("../../styles/fonts");
var _colors = _interopRequireDefault(require("../../styles/colors"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var textStyles = exports.textStyles = {
  // DEPRECATED: use type="display56" with color="white"
  Display1Light: {
    fontFamily: _fonts.proximaNovaExtrabold,
    fontSize: _fonts.fontSizes.s56,
    lineHeight: 1.07,
    color: _colors["default"].white
  },
  // DEPRECATED: use type="display56" with color="textPrimary"
  Display1Dark: {
    fontFamily: _fonts.proximaNovaExtrabold,
    fontSize: _fonts.fontSizes.s56,
    lineHeight: 1.07,
    color: _colors["default"].textPrimary
  },
  // DEPRECATED: use type="display48" with color="white"
  Display2LightExtrabold: {
    fontFamily: _fonts.proximaNovaExtrabold,
    fontSize: _fonts.fontSizes.s48,
    lineHeight: 1.04,
    color: _colors["default"].white
  },
  // DEPRECATED: use type="display48" with color="textPrimary"
  Display2DarkExtrabold: {
    fontFamily: _fonts.proximaNovaExtrabold,
    fontSize: _fonts.fontSizes.s48,
    lineHeight: 1.04,
    color: _colors["default"].textPrimary
  },
  Display2LightLight: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s48,
    fontWeight: 300,
    lineHeight: 1.04,
    color: _colors["default"].white
  },
  Display2DarkLight: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s48,
    fontWeight: 300,
    lineHeight: 1.04,
    color: _colors["default"].textPrimary
  },
  // DEPRECATED: use type="display40" with color="white"
  Display3LightExtrabold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s40,
    fontWeight: 700,
    lineHeight: 1.1,
    color: _colors["default"].white
  },
  // DEPRECATED: use type="display40" with color="textPrimary"
  Display3DarkExtrabold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s40,
    fontWeight: 700,
    lineHeight: 1.1,
    color: _colors["default"].textPrimary
  },
  Display3LightLight: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s40,
    fontWeight: 300,
    lineHeight: 1.1,
    color: _colors["default"].white
  },
  Display3DarkLight: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s40,
    fontWeight: 300,
    lineHeight: 1.1,
    color: _colors["default"].textPrimary
  },
  // DEPRECATED: use type="display32" with color="white"
  Display4Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s32,
    fontWeight: 700,
    lineHeight: 1.06,
    color: _colors["default"].white
  },
  // DEPRECATED: use type="display32" with color="textPrimary"
  Display4Dark: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s32,
    fontWeight: 700,
    lineHeight: 1.06,
    color: _colors["default"].textPrimary
  },
  // DEPRECATED: use type="display24" with color="white"
  Display5Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    fontWeight: 700,
    lineHeight: 1.08,
    color: _colors["default"].white
  },
  // DEPRECATED: use type="display24" with color="white"
  Display5Dark: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    fontWeight: 700,
    lineHeight: 1.08,
    color: _colors["default"].textPrimary
  },
  LinkSecondary1LightSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    fontWeight: 600,
    lineHeight: 1.29,
    color: _colors["default"].blue10
  },
  LinkSecondary1DarkSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    fontWeight: 600,
    lineHeight: 1.29,
    color: _colors["default"].blue20
  },
  LinkPrimary1Semibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    fontWeight: 600,
    lineHeight: 1.29,
    color: _colors["default"].neutral900
  },
  Body1Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    lineHeight: 1.29,
    color: _colors["default"].white
  },
  Body1DarkTertiary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    lineHeight: 1.29,
    color: _colors["default"].textTertiary
  },
  Body1DarkSecondary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    lineHeight: 1.29,
    color: _colors["default"].textTertiary
  },
  Body1DarkPrimary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    lineHeight: 1.29,
    color: _colors["default"].textPrimary
  },
  LinkSecondary1LightRegular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    lineHeight: 1.29,
    color: _colors["default"].blue10
  },
  LinkPrimary1Regular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    lineHeight: 1.29,
    color: _colors["default"].neutral900
  },
  LinkSecondary1DarkRegular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    lineHeight: 1.29,
    color: _colors["default"].blue20
  },
  LinkSecondary2LightSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    fontWeight: 600,
    lineHeight: 1.32,
    color: _colors["default"].blue10
  },
  LinkSecondary2DarkSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    fontWeight: 600,
    lineHeight: 1.32,
    color: _colors["default"].blue20
  },
  LinkPrimary2Semibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    fontWeight: 600,
    lineHeight: 1.32,
    color: _colors["default"].neutral900
  },
  Body2Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    lineHeight: 1.32,
    color: _colors["default"].white
  },
  Body2DarkTertiary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    lineHeight: 1.32,
    color: _colors["default"].textTertiary
  },
  Body2DarkSecondary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    lineHeight: 1.32,
    color: _colors["default"].textTertiary
  },
  Body2DarkPrimary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    lineHeight: 1.32,
    color: _colors["default"].textPrimary
  },
  LinkPrimary2Regular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    lineHeight: 1.32,
    color: _colors["default"].neutral900
  },
  LinkSecondary2DarkRegular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    lineHeight: 1.32,
    color: _colors["default"].blue20
  },
  LinkSecondary2LightRegular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    lineHeight: 1.32,
    color: _colors["default"].blue10
  },
  LinkSecondary3LightSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    fontWeight: 600,
    lineHeight: 1.3,
    color: _colors["default"].blue10
  },
  LinkSecondary3DarkSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    fontWeight: 600,
    lineHeight: 1.3,
    color: _colors["default"].blue20
  },
  LinkPrimary3Semibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    fontWeight: 600,
    lineHeight: 1.3,
    color: _colors["default"].neutral900
  },
  // DEPRECATED: use type="title20" with color="white"
  Title1Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    fontWeight: 600,
    lineHeight: 1.2,
    color: _colors["default"].white
  },
  // DEPRECATED: use type="title20" with color="textTertiary"
  Title1DarkTertiary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    fontWeight: 600,
    lineHeight: 1.2,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="title20" with color="textSecondary"
  Title1DarkSecondary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    fontWeight: 600,
    lineHeight: 1.2,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="title20" with color="textPrimary"
  Title1DarkPrimary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    fontWeight: 600,
    lineHeight: 1.2,
    color: _colors["default"].textPrimary
  },
  Body3Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    lineHeight: 1.3,
    color: _colors["default"].white
  },
  Body3DarkTertiary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    lineHeight: 1.3,
    color: _colors["default"].textTertiary
  },
  Body3DarkSecondary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    lineHeight: 1.3,
    color: _colors["default"].textTertiary
  },
  Body3DarkPrimary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    lineHeight: 1.3,
    color: _colors["default"].textPrimary
  },
  LinkSecondary3LightRegular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    lineHeight: 1.3,
    color: _colors["default"].blue10
  },
  LinkSecondary3DarkRegular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    lineHeight: 1.3,
    color: _colors["default"].blue20
  },
  LinkPrimary3Regular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    lineHeight: 1.3,
    color: _colors["default"].neutral900
  },
  LinkSecondary4LightSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    fontWeight: 600,
    lineHeight: 1.33,
    color: _colors["default"].blue10
  },
  LinkSecondary4DarkSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    fontWeight: 600,
    lineHeight: 1.33,
    color: _colors["default"].blue20
  },
  LinkPrimary4Semibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    fontWeight: 600,
    lineHeight: 1.33,
    color: _colors["default"].neutral900
  },
  Title2Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    fontWeight: 600,
    lineHeight: 1.22,
    color: _colors["default"].white
  },
  Title2DarkTertiary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    fontWeight: 600,
    lineHeight: 1.22,
    color: _colors["default"].textTertiary
  },
  Title2DarkSecondary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    fontWeight: 600,
    lineHeight: 1.22,
    color: _colors["default"].textTertiary
  },
  Title2DarkPrimary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    fontWeight: 600,
    lineHeight: 1.22,
    color: _colors["default"].textPrimary
  },
  Body4Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    lineHeight: 1.33,
    color: _colors["default"].white
  },
  Body4DarkTertiary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    lineHeight: 1.33,
    color: _colors["default"].textTertiary
  },
  Body4DarkSecondary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    lineHeight: 1.33,
    color: _colors["default"].textTertiary
  },
  Body4DarkPrimary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    lineHeight: 1.33,
    color: _colors["default"].textPrimary
  },
  LinkSecondary4DarkRegular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    lineHeight: 1.33,
    color: _colors["default"].blue20
  },
  LinkSecondary4LightRegular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    lineHeight: 1.33,
    color: _colors["default"].blue10
  },
  LinkPrimary4Regular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    lineHeight: 1.33,
    color: _colors["default"].neutral900
  },
  Subtitle1Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 600,
    lineHeight: 1.25,
    color: _colors["default"].white
  },
  Subtitle1DarkTertiary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 600,
    lineHeight: 1.25,
    color: _colors["default"].textTertiary
  },
  Subtitle1DarkSecondary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 600,
    lineHeight: 1.25,
    color: _colors["default"].textTertiary
  },
  // use new style: emphasis16 with neutral900
  Subtitle1DarkPrimary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 600,
    lineHeight: 1.25,
    color: _colors["default"].textPrimary
  },
  LinkSecondary5LightSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 600,
    lineHeight: 1.38,
    color: _colors["default"].blue10
  },
  LinkSecondary5DarkSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 600,
    lineHeight: 1.38,
    color: _colors["default"].blue20
  },
  Title3Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 600,
    lineHeight: 1.19,
    color: _colors["default"].white
  },
  Title3DarkTertiary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 600,
    lineHeight: 1.19,
    color: _colors["default"].textTertiary
  },
  Title3DarkSecondary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 600,
    lineHeight: 1.19,
    color: _colors["default"].textTertiary
  },
  Title3DarkPrimary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 600,
    lineHeight: 1.19,
    color: _colors["default"].textPrimary
  },
  Body5Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    lineHeight: 1.38,
    color: _colors["default"].white
  },
  Body5DarkTertiary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    lineHeight: 1.38,
    color: _colors["default"].textTertiary
  },
  Body5DarkSecondary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    lineHeight: 1.38,
    color: _colors["default"].textTertiary
  },
  // use new style: body16 with neutral900
  Body5DarkPrimary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    lineHeight: 1.38,
    color: _colors["default"].textPrimary
  },
  LinkSecondary5LightRegular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    lineHeight: 1.38,
    color: _colors["default"].blue10
  },
  LinkSecondary5DarkRegular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    lineHeight: 1.38,
    color: _colors["default"].blue20
  },
  Subtitle2Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    lineHeight: 1.29,
    color: _colors["default"].white
  },
  Subtitle2DarkTertiary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    lineHeight: 1.29,
    color: _colors["default"].textTertiary
  },
  // use new style: emphasis14 with neutral700
  Subtitle2DarkSecondary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    lineHeight: 1.29,
    color: _colors["default"].textTertiary
  },
  // use new style: emphasis14 with neutral900
  Subtitle2DarkPrimary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    lineHeight: 1.29,
    color: _colors["default"].textPrimary
  },
  LinkSecondary6LightSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    lineHeight: 1.29,
    color: _colors["default"].blue10
  },
  LinkSecondary6DarkSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    lineHeight: 1.29,
    color: _colors["default"].blue20
  },
  LinkPrimary6Semibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    color: _colors["default"].neutral900
  },
  Title4Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    lineHeight: 1.21,
    color: _colors["default"].white
  },
  Title4DarkTertiary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    lineHeight: 1.21,
    color: _colors["default"].textTertiary
  },
  Title4DarkSecondary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    lineHeight: 1.21,
    color: _colors["default"].textTertiary
  },
  // use new style: emphasis14 with neutral900
  Title4DarkPrimary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    lineHeight: 1.21,
    color: _colors["default"].textPrimary
  },
  LinkSecondary6LightRegular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    lineHeight: 1.29,
    color: _colors["default"].blue10
  },
  LinkSecondary6DarkRegular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    lineHeight: 1.29,
    color: _colors["default"].blue20
  },
  Body6Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    lineHeight: 1.29,
    color: _colors["default"].white
  },
  Body6DarkTertiary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    lineHeight: 1.29,
    color: _colors["default"].textTertiary
  },
  // use new style: body14 with neutral700
  Body6DarkSecondary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    lineHeight: 1.29,
    color: _colors["default"].textTertiary
  },
  // use new style: body14 with neutral900
  Body6DarkPrimary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    lineHeight: 1.29,
    color: _colors["default"].textPrimary
  },
  LinkPrimary6Regular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    color: _colors["default"].neutral900
  },
  Subtitle3Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    fontWeight: 600,
    lineHeight: 1.17,
    color: _colors["default"].white
  },
  Subtitle3DarkTertiary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    fontWeight: 600,
    lineHeight: 1.17,
    color: _colors["default"].textTertiary
  },
  Subtitle3DarkSecondary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    fontWeight: 600,
    lineHeight: 1.17,
    color: _colors["default"].textTertiary
  },
  Subtitle3DarkPrimary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    fontWeight: 600,
    lineHeight: 1.17,
    color: _colors["default"].textPrimary
  },
  LinkSecondary7LightSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    fontWeight: 600,
    lineHeight: 1.25,
    color: _colors["default"].blue10
  },
  Caption1Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    lineHeight: 1.25,
    color: _colors["default"].white
  },
  Caption1DarkTertiary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    lineHeight: 1.25,
    color: _colors["default"].textTertiary
  },
  // use new style: caption12 with neutral700
  Caption1DarkSecondary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    lineHeight: 1.25,
    color: _colors["default"].textTertiary
  },
  Caption1DarkPrimary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    lineHeight: 1.25,
    color: _colors["default"].textPrimary
  },
  LinkSecondary7LightRegular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    lineHeight: 1.25,
    color: _colors["default"].blue10
  },
  LinkSecondary7DarkRegular: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    lineHeight: 1.25,
    color: _colors["default"].blue20
  },
  LinkSecondary7DarkSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    fontWeight: 600,
    lineHeight: 1.25,
    color: _colors["default"].blue20
  },
  Caption2Light: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s10,
    lineHeight: 1.3,
    color: _colors["default"].white
  },
  Caption2DarkTertiary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s10,
    lineHeight: 1.3,
    color: _colors["default"].textTertiary
  },
  Caption2DarkSecondary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s10,
    lineHeight: 1.3,
    color: _colors["default"].textTertiary
  },
  Caption2DarkPrimary: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s10,
    lineHeight: 1.3,
    color: _colors["default"].textPrimary
  },
  Error1: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    lineHeight: 1.29,
    color: _colors["default"].red50
  },
  Error2: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    lineHeight: 1.29,
    color: _colors["default"].red50
  },
  Error3: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    lineHeight: 1.25,
    color: _colors["default"].red50
  },
  Error3SemiBold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    lineHeight: 1.38,
    fontWeight: 600,
    color: _colors["default"].red50
  },
  h1: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s40,
    fontWeight: 800,
    lineHeight: 1.25,
    color: _colors["default"].blue90
  },
  h2: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s32,
    fontWeight: 600,
    lineHeight: 1.2,
    color: _colors["default"].blue90
  },
  h3: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s24,
    fontWeight: 600,
    lineHeight: 1.17,
    color: _colors["default"].blue90
  },
  h4: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    fontWeight: 700,
    lineHeight: 1.2,
    color: _colors["default"].blue90
  },
  'Link-SemiBold-Extra-large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    fontWeight: 600,
    lineHeight: 1.4,
    color: _colors["default"].neutral900
  },
  'Emphasis-Tertiary-Extra-large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    fontWeight: 600,
    lineHeight: 1.2,
    color: _colors["default"].textTertiary
  },
  'Emphasis-Secondary-Extra-Large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    fontWeight: 600,
    lineHeight: 1.2,
    color: _colors["default"].textTertiary
  },
  'Emphasis-Extra-large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    fontWeight: 600,
    lineHeight: 1.2,
    color: _colors["default"].textPrimary
  },
  'Link-Regular-Extra-large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    lineHeight: 1.4,
    color: _colors["default"].neutral900
  },
  'Body-Tertiary-Extra-large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    lineHeight: 1.4,
    color: _colors["default"].textTertiary
  },
  'Body-Secondary-Extra-large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    lineHeight: 1.4,
    color: _colors["default"].textTertiary
  },
  'Body-Extra-large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s20,
    lineHeight: 1.4,
    color: _colors["default"].textPrimary
  },
  'Link-SemiBold-Large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    fontWeight: 600,
    lineHeight: 1.44,
    color: _colors["default"].neutral900
  },
  // DEPRECATED: use type="emphasis18" with color="textTertiary"
  'Emphasis-Tertiary-Large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    fontWeight: 600,
    lineHeight: 1.22,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="emphasis18" with color="textSecondary"
  'Emphasis-Secondary-Large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    fontWeight: 600,
    lineHeight: 1.22,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="emphasis18" with color="offBlack50"
  'Emphasis-Large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    fontWeight: 600,
    lineHeight: 1.22,
    color: _colors["default"].textPrimary
  },
  // DEPRECATED: use type="body18" with color="offBlack50"
  'Link-Regular-Large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    lineHeight: 1.44,
    color: _colors["default"].neutral900
  },
  // DEPRECATED: use type="body18" with color="textTertiary"
  'Body-Tertiary-Large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    lineHeight: 1.44,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="body18" with color="textSecondary"
  'Body-Secondary-Large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    lineHeight: 1.44,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="body18" with color="textPrimary"
  'Body-Large': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s18,
    lineHeight: 1.44,
    color: _colors["default"].textPrimary
  },
  h5: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 700,
    lineHeight: 1.25,
    color: _colors["default"].blue90
  },
  // DEPRECATED: use type="emphasis16" with color="offBlack50"
  'Link-SemiBold-Medium': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 600,
    lineHeight: 1.38,
    color: _colors["default"].neutral900
  },
  // DEPRECATED: use type="emphasis16" with color="textTertiary"
  'Emphasis-Tertiary-Medium': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 600,
    lineHeight: 1.25,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="emphasis16" with color="textSecondary"
  'Emphasis-Secondary-Medium': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 600,
    lineHeight: 1.25,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="emphasis16" with color="textPrimary"
  'Emphasis-Medium': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 600,
    lineHeight: 1.25,
    color: _colors["default"].textPrimary
  },
  // DEPRECATED: use type="body16" with color="offBlack50"
  'Link-Regular-Medium': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    lineHeight: 1.38,
    color: _colors["default"].neutral900
  },
  // DEPRECATED: use type="body16" with color="textTertiary"
  'Body-Tertiary-Medium': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    lineHeight: 1.38,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="body16" with color="textSecondary"
  'Body-Secondary-Medium': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    lineHeight: 1.38,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="body16" with color="textPrimary"
  'Body-Medium': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    lineHeight: 1.38,
    color: _colors["default"].textPrimary
  },
  // DEPRECATED: use type="emphasis14" with color="offBlack50"
  'Link-SemiBold-Small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    lineHeight: 1.29,
    color: _colors["default"].neutral900
  },
  // DEPRECATED: use type="emphasis14" with color="textTertiary"
  'Emphasis-Tertiary-Small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    lineHeight: 1.29,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="emphasis14" with color="textSecondary"
  'Emphasis-Secondary-Small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    lineHeight: 1.29,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="emphasis14" with color="textPrimary"
  'Emphasis-Small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    lineHeight: 1.29,
    color: _colors["default"].textPrimary
  },
  // DEPRECATED: use type="body14" with color="offBlack50"
  'Link-Regular-Small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    lineHeight: 1.29,
    color: _colors["default"].neutral900
  },
  // DEPRECATED: use type="body14" with color="textTertiary"
  'Body-Tertiary-Small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    lineHeight: 1.29,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="body14" with color="textSecondary"
  'Body-Secondary-Small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    lineHeight: 1.29,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="body14" with color="textPrimary"
  'Body-Small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    lineHeight: 1.29,
    color: _colors["default"].textPrimary
  },
  // DEPRECATED: use type="emphasis12" with color="offBlack50"
  'Link-SemiBold-Extra-small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    fontWeight: 600,
    lineHeight: 1.25,
    color: _colors["default"].neutral900
  },
  // DEPRECATED: use type="emphasis12" with color="textTertiary"
  'Emphasis-Tertiary-Extra-small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    fontWeight: 600,
    lineHeight: 1.25,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="emphasis12" with color="textSecondary"
  'Emphasis-Secondary-Extra-small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    fontWeight: 600,
    lineHeight: 1.25,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="emphasis12" with color="textPrimary"
  'Emphasis-Extra-small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    fontWeight: 600,
    lineHeight: 1.25,
    color: _colors["default"].textPrimary
  },
  // DEPRECATED: use type="body12" with color="offBlack50"
  'Link-Regular-Extra-small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    lineHeight: 1.25,
    color: _colors["default"].neutral900
  },
  // DEPRECATED: use type="body12" with color="textTertiary"
  'Body-Tertiary-Extra-small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    lineHeight: 1.25,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="body12" with color="textSecondary"
  'Body-Secondary-Extra-small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    lineHeight: 1.25,
    color: _colors["default"].textTertiary
  },
  // DEPRECATED: use type="body12" with color="textPrimary"
  'Body-Extra-small': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    lineHeight: 1.25,
    color: _colors["default"].textPrimary
  },
  // DEPRECATED: use type="body12" with color="red50"
  'Helper-Text': {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    lineHeight: 1.25,
    color: _colors["default"].red50
  },
  // DEPRECATED: use type="emphasis12" with color="white"
  BlockLabelWhite: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s12,
    fontWeight: 600,
    lineHeight: 1.25,
    color: _colors["default"].white
  },
  // DEPRECATED: use type="emphasis16" with color="textTertiary"
  Body5GreenSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s16,
    fontWeight: 600,
    lineHeight: 1.38,
    color: _colors["default"].green50
  },
  // DEPRECATED: use type="emphasis14" with color="green50"
  Body6GreenSemibold: {
    fontFamily: _fonts.proximaNova,
    fontSize: _fonts.fontSizes.s14,
    fontWeight: 600,
    lineHeight: 1.29,
    color: _colors["default"].green50
  }
};
var baseStyles = {
  display: {
    fontFamily: _fonts.proximaNova,
    fontWeight: 700
  },
  serifDisplay: {
    fontFamily: _fonts.stkBureauSerif,
    fontWeight: 400
  },
  title: {
    fontFamily: _fonts.proximaNova,
    fontWeight: 600
  },
  subtitle: {
    fontFamily: _fonts.proximaNova,
    fontWeight: 600,
    textTransform: 'uppercase'
  },
  body: {
    fontFamily: _fonts.proximaNova,
    fontWeight: 400
  },
  emphasis: {
    fontFamily: _fonts.proximaNova,
    fontWeight: 600
  },
  caption: {
    fontFamily: _fonts.proximaNova,
    fontWeight: 400
  }
};
var newTextStyles = exports.newTextStyles = {
  display56: _objectSpread(_objectSpread({}, baseStyles.display), {}, {
    fontSize: '56px',
    lineHeight: '60px'
  }),
  display48: _objectSpread(_objectSpread({}, baseStyles.display), {}, {
    fontSize: '48px',
    lineHeight: '50px'
  }),
  display40: _objectSpread(_objectSpread({}, baseStyles.display), {}, {
    fontSize: '40px',
    lineHeight: '44px'
  }),
  display32: _objectSpread(_objectSpread({}, baseStyles.display), {}, {
    fontSize: '32px',
    lineHeight: '34px'
  }),
  display24: _objectSpread(_objectSpread({}, baseStyles.display), {}, {
    fontSize: '24px',
    lineHeight: '26px'
  }),
  display20: _objectSpread(_objectSpread({}, baseStyles.display), {}, {
    fontSize: '20px',
    lineHeight: '26px'
  }),
  display10: _objectSpread(_objectSpread({}, baseStyles.display), {}, {
    fontSize: '10px',
    lineHeight: '13px'
  }),
  serifDisplay56: _objectSpread(_objectSpread({}, baseStyles.serifDisplay), {}, {
    fontSize: '56px',
    lineHeight: '60px'
  }),
  serifDisplay48: _objectSpread(_objectSpread({}, baseStyles.serifDisplay), {}, {
    fontSize: '48px',
    lineHeight: '50px'
  }),
  serifDisplay40: _objectSpread(_objectSpread({}, baseStyles.serifDisplay), {}, {
    fontSize: '40px',
    lineHeight: '44px'
  }),
  serifDisplay32: _objectSpread(_objectSpread({}, baseStyles.serifDisplay), {}, {
    fontSize: '32px',
    lineHeight: '34px'
  }),
  serifDisplay24: _objectSpread(_objectSpread({}, baseStyles.serifDisplay), {}, {
    fontSize: '24px',
    lineHeight: '26px'
  }),
  title10: _objectSpread(_objectSpread({}, baseStyles.title), {}, {
    fontSize: '10px',
    lineHeight: '13px'
  }),
  title20: _objectSpread(_objectSpread({}, baseStyles.title), {}, {
    fontSize: '20px',
    lineHeight: '24px'
  }),
  title18: _objectSpread(_objectSpread({}, baseStyles.title), {}, {
    fontSize: '18px',
    lineHeight: '22px'
  }),
  title16: _objectSpread(_objectSpread({}, baseStyles.title), {}, {
    fontSize: '16px',
    lineHeight: '19px'
  }),
  title14: _objectSpread(_objectSpread({}, baseStyles.title), {}, {
    fontSize: '14px',
    lineHeight: '17px'
  }),
  subtitle16: _objectSpread(_objectSpread({}, baseStyles.subtitle), {}, {
    fontSize: '16px',
    lineHeight: '20px'
  }),
  subtitle14: _objectSpread(_objectSpread({}, baseStyles.subtitle), {}, {
    fontSize: '14px',
    lineHeight: '18px'
  }),
  subtitle12: _objectSpread(_objectSpread({}, baseStyles.subtitle), {}, {
    fontSize: '12px',
    lineHeight: '14px'
  }),
  body32: _objectSpread(_objectSpread({}, baseStyles.body), {}, {
    fontSize: '32px',
    lineHeight: '40px'
  }),
  body24: _objectSpread(_objectSpread({}, baseStyles.body), {}, {
    fontSize: '24px',
    lineHeight: '32px'
  }),
  body22: _objectSpread(_objectSpread({}, baseStyles.body), {}, {
    fontSize: '22px',
    lineHeight: '30px'
  }),
  body20: _objectSpread(_objectSpread({}, baseStyles.body), {}, {
    fontSize: '20px',
    lineHeight: '28px'
  }),
  body18: _objectSpread(_objectSpread({}, baseStyles.body), {}, {
    fontSize: '18px',
    lineHeight: '26px'
  }),
  body16: _objectSpread(_objectSpread({}, baseStyles.body), {}, {
    fontSize: '16px',
    lineHeight: '22px'
  }),
  body14: _objectSpread(_objectSpread({}, baseStyles.body), {}, {
    fontSize: '14px',
    lineHeight: '18px'
  }),
  body12: _objectSpread(_objectSpread({}, baseStyles.body), {}, {
    fontSize: '12px',
    lineHeight: '15px'
  }),
  emphasis40: _objectSpread(_objectSpread({}, baseStyles.emphasis), {}, {
    fontSize: '40px',
    lineHeight: '48px'
  }),
  emphasis32: _objectSpread(_objectSpread({}, baseStyles.emphasis), {}, {
    fontSize: '32px',
    lineHeight: '40px'
  }),
  emphasis24: _objectSpread(_objectSpread({}, baseStyles.emphasis), {}, {
    fontSize: '24px',
    lineHeight: '32px'
  }),
  emphasis22: _objectSpread(_objectSpread({}, baseStyles.emphasis), {}, {
    fontSize: '22px',
    lineHeight: '30px'
  }),
  emphasis20: _objectSpread(_objectSpread({}, baseStyles.emphasis), {}, {
    fontSize: '20px',
    lineHeight: '28px'
  }),
  emphasis18: _objectSpread(_objectSpread({}, baseStyles.emphasis), {}, {
    fontSize: '18px',
    lineHeight: '26px'
  }),
  emphasis16: _objectSpread(_objectSpread({}, baseStyles.emphasis), {}, {
    fontSize: '16px',
    lineHeight: '22px'
  }),
  emphasis14: _objectSpread(_objectSpread({}, baseStyles.emphasis), {}, {
    fontSize: '14px',
    lineHeight: '18px'
  }),
  emphasis12: _objectSpread(_objectSpread({}, baseStyles.emphasis), {}, {
    fontSize: '12px',
    lineHeight: '15px'
  }),
  emphasis10: _objectSpread(_objectSpread({}, baseStyles.emphasis), {}, {
    fontSize: '10px',
    lineHeight: '13px'
  }),
  caption12: _objectSpread(_objectSpread({}, baseStyles.caption), {}, {
    fontSize: '12px',
    lineHeight: '15px'
  }),
  caption10: _objectSpread(_objectSpread({}, baseStyles.caption), {}, {
    fontSize: '10px',
    lineHeight: '13px'
  }),
  error1: _objectSpread(_objectSpread({}, textStyles.Error3SemiBold), {}, {
    fontSize: _fonts.fontSizes.s14
  })
};
//# sourceMappingURL=HBText.styles.js.map